import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import type { IGiphyGif } from "@/shared/types";
import { GIF_MASONRY_COLS } from "../constants";
import type { IGifs } from "../types";
import { giphyGifsToGifsCols } from "../utils";

interface IState {
  columnsData: IGifs[][];
  category: string;
  queryRaw: string;
}

interface IActions {
  setColumnsData: (data: { gifs: IGiphyGif[]; extend?: boolean }) => void;
  setCategory: (value: string) => void;
  setQueryRaw: (value: string) => void;
  reset: () => void;
}

const initState: IState = {
  columnsData: Array.from({ length: GIF_MASONRY_COLS }, () => []),
  category: "money",
  queryRaw: "",
};

export const useGifsStore = create<IState & IActions>((set) => ({
  ...initState,
  setColumnsData: ({ gifs, extend }) => {
    set((s) => ({
      columnsData: giphyGifsToGifsCols({ gifs, extend })(s.columnsData),
    }));
  },
  setCategory: (category) => set({ category }),
  setQueryRaw: (queryRaw) => set({ queryRaw }),
  reset: () => set(initState),
}));

export const useGifsStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useGifsStore(useShallow(selector));
};
